import { render, staticRenderFns } from "./ScoreSetStats.vue?vue&type=template&id=d963b6e4"
import script from "./ScoreSetStats.vue?vue&type=script&lang=js"
export * from "./ScoreSetStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports